// function openSizePopup(e){let t=document.querySelector("#size-pd-chart");""!=e.trim()?(t.querySelector(".size-pd-chart-content").innerHTML=e,t.classList.add("show"),document.querySelector("body").style.overflow="hidden"):alert("Size chart not found! May be this product has only ONE SIZE.")}function closeSizePopup(){document.querySelector("#size-pd-chart").classList.remove("show"),document.querySelector("body").style.overflow=""}function waitListReuest(e,t,l=null){try{fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",{headers:{accept:"application/json, text/plain, */*","content-type":"application/x-www-form-urlencoded;charset=UTF-8"},body:new URLSearchParams({a:"PAgcrr",email:e,platform:"shopify",variant:t}),method:"POST"}).then((e=>{if(console.log(e),1==e.ok){if(console.log("waitlist true"),null!=l){let e=l.closest(".product-upsell__holder");return e.querySelector(".waitlist-modal_form").classList.add("hidden"),e.querySelector(".waitlist-modal_success").classList.add("show"),void setTimeout((function(){e.querySelector(".waitlist-modal_success").classList.remove("show"),e.querySelector(".email_input").value="",e.querySelector(".waitlist-modal_form").classList.remove("hidden")}),3e3)}document.querySelector(".waitlist-modal_form").classList.add("hidden"),document.querySelector(".waitlist-modal_success").classList.add("show"),setTimeout(closeWaitList,3e3)}})).catch((e=>{console.log(e)}))}catch(e){console.log(e)}}function closeWaitList(){document.querySelector(".waitlist-modal_form").classList.remove("hidden"),document.querySelector(".waitlist-modal_success").classList.remove("show"),document.querySelector(".waitlist-modal-js").querySelector(".email_input").value=""}function mySubmitFunction(e){e.preventDefault();const t=e.target.elements.email.value,l=e.target.elements.id.value;return console.log(t,l),waitListReuest(t,l),!1}function openModalWaitlist(){document.querySelector(".waitlist-modal-js").classList.add("show"),document.querySelector("#btn-waitlist-modal-show-js").classList.add("hidden")}function showAllLinksInDrawer(e){e.closest(".mobile__menu__dropdown").classList.remove("is-hiding")}function changeVariantId(e,t,l){let o=findIdVariantInJson(e,t);l.closest(".product-upsell__holder").querySelector(".varId").value=o,console.log(l.closest(".product-upsell__holder").querySelector(".varId").value),closeWaitListUpsell(l)}function findIdVariantInJson(e,t){let l=null;return e.variants.forEach((e=>{e.option1!==t&&e.option2!==t&&e.option3!==t||(console.log(e.id),l=e.id)})),l}function openWaitListUpsell(e,t,l){try{let o=findIdVariantInJson(e,t),s=l.closest(".product-upsell__holder");s.querySelector(".waitlist-modal-upsell-js").classList.add("show"),console.log(s.querySelector(".variantId_input").value),s.querySelector(".variantId_input").value=o,s.querySelector(".btn--upsell-custom").classList.add("hidden")}catch(e){console.log(e)}try{l.closest(".btn--upsell-mobile").querySelector("button").style.display="none"}catch(e){console.log(e)}}function closeWaitListUpsell(e){try{let t=e.closest(".product-upsell__holder");t.querySelector(".waitlist-modal-upsell-js").classList.remove("show"),t.querySelector(".btn--upsell-custom").classList.remove("hidden"),t.querySelector(".waitlist-modal_form").classList.remove("hidden")}catch(e){console.log(e)}try{e.closest(".btn--upsell-mobile").querySelector("button").style.display="block"}catch(e){console.log(e)}}function mySubmitFunctionUpsell(e,t){e.preventDefault();const l=e.target.elements.email.value,o=e.target.elements.id.value;return console.log(l,o),waitListReuest(l,o,t),!1}function selectChangeVariant(e,t,l){if(console.log(t),t.includes("sold")){let o=t.split(" ")[0];console.log(o),openWaitListUpsell(e,o,l)}else changeVariantId(e,t,l),closeWaitListUpsell(l)}document.querySelector("#size-pd-chart").addEventListener("click",(function(e){!e.target.matches("#size-pd-chart")&&e.target.closest(".show")||closeSizePopup()})),document.querySelectorAll(".sliderow--back").forEach((e=>{e.addEventListener("click",(function(t){t.preventDefault(),e.parentElement.classList.remove("is-visible"),showAllLinksInDrawer(e),e.classList.contains("link_level_next-1")&&document.querySelector(".drawer__menu").querySelectorAll(".sliderow-firstlevel").forEach((e=>{e.classList.remove("is-hiding")})),e.classList.contains("link_level_next-2")&&document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.classList.remove("is-hiding-hidden")}))}))})),document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.addEventListener("click",(function(){document.querySelector(".drawer__menu").querySelectorAll(".btn_level-2").forEach((e=>{e.classList.add("is-hiding-hidden")}))}))})),document.querySelectorAll(".sliderow-firstlevel").forEach((e=>{e.addEventListener("click",(function(){console.log("click"),document.querySelectorAll(".sliderow-firstlevel").forEach((e=>e.classList.add("is-hiding")))}))}));



function tabBtns() {
	try {
		const tabBtns = document.querySelectorAll('.more-tabs__btns')
		tabBtns.forEach(b => {
			b.addEventListener('click', () => {
				tabBtns.forEach(btn => {
					btn.classList.remove('active')
				})
				b.classList.add('active')

				let type = b.getAttribute('data-sanitized-tabstype')

				if (!type) {
					type = b.getAttribute('tabstype')
				}

				const tabs = document.querySelectorAll('.tab-sizeguide')
				tabs.forEach(t => {
					t.style.display = "none"

					console.log(t.getAttribute('typetable'), type)

					if (t.getAttribute('typetable') == type || t.getAttribute('data-sanitized-typetable') == type) {
						t.style.display = "block"
					}
				})

			})
		})
	} catch (err) {
		console.log(err)
	}
}


function SizeGuideOpenPage(parentSelector) {
	try {
		const form = document.querySelector(parentSelector).querySelector('.size-guides__form-selector')
		if (!form) return
		form.addEventListener('change', function (event) {
			if (event.target.type === 'radio') {
				const selectedValue = event.target.value
				console.log(`Selected unit: ${selectedValue}`)

				const closestWrap = form.closest('.size-guides-wrapper')
				if (closestWrap) {

					let guidTypeAtr = closestWrap.querySelectorAll('[size-guide-type]')

					if (guidTypeAtr.length == 0) {
						guidTypeAtr = closestWrap.querySelectorAll('[data-sanitized-size-guide-type]')
					}
					console.log(guidTypeAtr)

					guidTypeAtr.forEach(element => {
						let sizeGuideType = element.getAttribute('size-guide-type')

						if (!sizeGuideType) {
							sizeGuideType = element.getAttribute('data-sanitized-size-guide-type')
						}
						element.classList.add('hidden')
						if (sizeGuideType === selectedValue) {
							element.classList.remove('hidden')
						}
					})
				}
			}
		})
		tabBtns()
	} catch (err) {
		console.log(err)
	}
}

SizeGuideOpenPage('.template-page .main-content')


function opentabAk(selector) {
	try {
		const tabs = document.querySelectorAll(selector)
		const tables = document.querySelectorAll('.table-container')
		tabs.forEach(btn => {
			btn.addEventListener('click', () => {
				btn.classList.toggle('active')
				const tabname = btn.getAttribute('data-sanitized-tabak')
				console.log(tabname)
				tables.forEach(t => {
					if (t.getAttribute('data-sanitized-tabak-table') === tabname && btn.classList.contains('active')) {
						t.style.display = "block"
					} else if (t.getAttribute('data-sanitized-tabak-table') === tabname) {
						t.style.display = "none"
					}
				})
			})
		})
	} catch (e) {
		console.error(e)
	}
}

opentabAk('.template-page .tab_ak')

function SizeGuideOpen(parentSelector) {
	try {

		const form = document.querySelector('#size-pd-chart .size-guides__form-selector')
		console.log(form)
		if (!form) {
			console.log('form not found')
			return
		}

		let tables = document.querySelectorAll('#size-pd-chart [size-guide-type]')

		if (tables.length == 0) {
			tables = document.querySelectorAll('#size-pd-chart [data-sanitized-size-guide-type]')
		}

		form.querySelectorAll('label').forEach(e => {
			e.addEventListener('click', () => {
				console.log(e.getAttribute('for'))
				form.querySelectorAll('input').forEach(el => {
					if (el.value == e.getAttribute('for')) {
						el.checked = true

						tables.forEach(t => {
							t.classList.add('hidden')
							if (el.value == t.getAttribute('size-guide-type') || el.value == t.getAttribute('data-sanitized-size-guide-type')) {
								t.classList.remove('hidden')
							}
						})
					} else {
						el.checked = false
					}
				})
			})
		})

		// form.addEventListener('change', function (event) {
		// 	if (event.target.type === 'radio') {
		// 		const selectedValue = event.target.value
		// 		console.log(`Selected unit: ${selectedValue}`)

		// 		const closestWrap = form.closest('.size-guides-wrapper')
		// 		if (closestWrap) {
		// 			closestWrap.querySelectorAll('[size-guide-type]').forEach(element => {
		// 				const sizeGuideType = element.getAttribute('size-guide-type')
		// 				element.classList.add('hidden')
		// 				if (sizeGuideType === selectedValue) {
		// 					element.classList.remove('hidden')
		// 				}
		// 			})
		// 		}
		// 	}
		// })
		tabBtns()
	} catch (err) {
		console.log(err)
	}
}

SizeGuideOpenPage('.template-page .main-content')


function openSizePopup(e) {
	let t = document.querySelector("#size-pd-chart")
	"" != e.trim() ? ((t.querySelector(".size-pd-chart-content").innerHTML = e), t.classList.add("show"), (document.querySelector("body").style.overflow = "hidden")) : alert("Size chart not found! May be this product has only ONE SIZE.")
	SizeGuideOpen('#size-pd-chart')
	opentabAk('.size-pd-chart-content .tab_ak')
	// setTimeout(SizeGuideOpen, 100, ".size-pd-chart-content"); 
}

function closeSizePopup() {
	document.querySelector("#size-pd-chart").classList.remove("show"), (document.querySelector("body").style.overflow = "")
}

function waitListReuest(e, t, l = null) {
	try {
		fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
			headers: {
				accept: "application/json, text/plain, */*",
				"content-type": "application/x-www-form-urlencoded;charset=UTF-8"
			},
			body: new URLSearchParams({ a: "PAgcrr", email: e, platform: "shopify", variant: t }),
			method: "POST",
		})
			.then((e) => {
				if ((console.log(e), 1 == e.ok)) {
					if ((console.log("waitlist true"), null != l)) {
						let e = l.closest(".product-upsell__holder")
						return (
							e.querySelector(".waitlist-modal_form").classList.add("hidden"),
							e.querySelector(".waitlist-modal_success").classList.add("show"),
							void setTimeout(function () {
								e.querySelector(".waitlist-modal_success").classList.remove("show"), (e.querySelector(".email_input").value = ""), e.querySelector(".waitlist-modal_form").classList.remove("hidden")
							}, 3e3)
						)
					}
					document.querySelector(".waitlist-modal_form").classList.add("hidden"), document.querySelector(".waitlist-modal_success").classList.add("show"), setTimeout(closeWaitList, 3e3)
				}
			})
			.catch((e) => {
				console.log(e)
			})
	} catch (e) {
		console.log(e)
	}
}

function closeWaitList() {
	document.querySelector(".waitlist-modal_form").classList.remove("hidden"),
		document.querySelector(".waitlist-modal_success").classList.remove("show"),
		(document.querySelector(".waitlist-modal-js").querySelector(".email_input").value = "")
}

function mySubmitFunction(e) {
	e.preventDefault()
	const t = e.target.elements.email.value,
		l = e.target.elements.id.value
	return console.log(t, l), waitListReuest(t, l), !1
}

function openModalWaitlist() {
	document.querySelector(".waitlist-modal-js").classList.add("show"), document.querySelector("#btn-waitlist-modal-show-js").classList.add("hidden")
}

function showAllLinksInDrawer(e) {
	e.closest(".mobile__menu__dropdown").classList.remove("is-hiding")
}

function changeVariantId(e, t, l) {
	let o = findIdVariantInJson(e, t);
	(l.closest(".product-upsell__holder").querySelector(".varId").value = o), console.log(l.closest(".product-upsell__holder").querySelector(".varId").value), closeWaitListUpsell(l)
}

function findIdVariantInJson(e, t) {
	let l = null
	return (
		e.variants.forEach((e) => {
			(e.option1 !== t && e.option2 !== t && e.option3 !== t) || (console.log(e.id), (l = e.id))
		}),
		l
	)
}

function openWaitListUpsell(e, t, l) {
	try {
		let o = findIdVariantInJson(e, t),
			s = l.closest(".product-upsell__holder")
		s.querySelector(".waitlist-modal-upsell-js").classList.add("show"),
			console.log(s.querySelector(".variantId_input").value),
			(s.querySelector(".variantId_input").value = o),
			s.querySelector(".btn--upsell-custom").classList.add("hidden")
	} catch (e) {
		console.log(e)
	}
	try {
		l.closest(".btn--upsell-mobile").querySelector("button").style.display = "none"
	} catch (e) {
		console.log(e)
	}
}

function closeWaitListUpsell(e) {
	try {
		let t = e.closest(".product-upsell__holder")
		t.querySelector(".waitlist-modal-upsell-js").classList.remove("show"), t.querySelector(".btn--upsell-custom").classList.remove("hidden"), t.querySelector(".waitlist-modal_form").classList.remove("hidden")
	} catch (e) {
		console.log(e)
	}
	try {
		e.closest(".btn--upsell-mobile").querySelector("button").style.display = "block"
	} catch (e) {
		console.log(e)
	}
}

function mySubmitFunctionUpsell(e, t) {
	e.preventDefault()
	const l = e.target.elements.email.value,
		o = e.target.elements.id.value
	return console.log(l, o), waitListReuest(l, o, t), !1
}

function selectChangeVariant(e, t, l) {
	if ((console.log(t), t.includes("sold"))) {
		let o = t.split(" ")[0]
		console.log(o), openWaitListUpsell(e, o, l)
	} else changeVariantId(e, t, l), closeWaitListUpsell(l)
}

document.querySelector("#size-pd-chart").addEventListener("click", function (e) {
	(!e.target.matches("#size-pd-chart") && e.target.closest(".show")) || closeSizePopup()
}),
	document.querySelectorAll(".sliderow--back").forEach((e) => {
		e.addEventListener("click", function (t) {
			t.preventDefault(),
				e.parentElement.classList.remove("is-visible"),
				showAllLinksInDrawer(e),
				e.classList.contains("link_level_next-1") &&
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".sliderow-firstlevel")
					.forEach((e) => {
						e.classList.remove("is-hiding")
					}),
				e.classList.contains("link_level_next-2") &&
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".btn_level-2")
					.forEach((e) => {
						e.classList.remove("is-hiding-hidden")
					})
		})
	}),
	document
		.querySelector(".drawer__menu")
		.querySelectorAll(".btn_level-2")
		.forEach((e) => {
			e.addEventListener("click", function () {
				document
					.querySelector(".drawer__menu")
					.querySelectorAll(".btn_level-2")
					.forEach((e) => {
						e.classList.add("is-hiding-hidden")
					})
			})
		}),
	document.querySelectorAll(".sliderow-firstlevel").forEach((e) => {
		e.addEventListener("click", function () {
			console.log("click"), document.querySelectorAll(".sliderow-firstlevel").forEach((e) => e.classList.add("is-hiding"))
		})
	})


function delHeadingsSizeGuidePages() {
	try {
		const heading = document.querySelector('.template-page .standard__heading')
		if (!heading) return
		if (heading.innerText.includes('SIZE GUIDE') || heading.innerText.includes('MEASUREMENTS')) {
			heading.style.display = 'none'
		}
	} catch (e) {
		console.error(e)
	}
}

delHeadingsSizeGuidePages();



class sizeGuideAccordion extends HTMLElement {
    constructor() {
        super()
        const iteam = this
        const header = this.querySelector('.accardion-size-guides__iteam_header')
        const content = this.querySelector('.accardion-size-guides__iteam_content')

        header.addEventListener('click', () => {
            if (content.classList.contains('hidden')) {
                content.classList.remove('hidden')
                header.classList.add('show')
            } else {
                content.classList.add('hidden')
                header.classList.remove('show')
            }
        })


        try {
            const form = iteam.querySelector('.size-guides__form-selector')

            if (!form) return

            let tables = iteam.querySelectorAll(' [size-guide-type]')

            if (tables.length == 0) {
                tables = iteam.querySelectorAll(' [data-sanitized-size-guide-type]')
            }

            form.querySelectorAll('label').forEach(e => {
                e.addEventListener('click', () => {
                    console.log(e.getAttribute('for'))
                    form.querySelectorAll('input').forEach(el => {
                        console.log(el.value == e.getAttribute('for'))

                        if (el.value == e.getAttribute('for')) {
                            el.checked = true


                            console.log('tables', tables)
                            tables.forEach(t => {
                                t.classList.add('hidden')
                                if (el.value == t.getAttribute('size-guide-type') || el.value == t.getAttribute('data-sanitized-size-guide-type')) {
                                    t.classList.remove('hidden')
                                }
                            })
                        } else {
                            el.checked = false
                        }
                    })

                    tabBtns()
                })
            })



        } catch (err) {
            console.log(err)
        }


    }
}

customElements.define('accardion-size-guides', sizeGuideAccordion);
